<template>
  <form v-on:submit.prevent="click" v-if="collection">

    <div class="row">
      <div class="col-md-12">
        <!-- Custom Tabs -->
        <div class="nav-tabs-custom">
          <ul class="nav nav-tabs">
            <li class="active">
              <a href="#tab_1" data-toggle="tab">Generali</a>
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane active" id="tab_1">
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="title">Titolo</label>
                        <input type="text" class="form-control" id="title"
                               name="title"
                               v-model="collection.title" :disabled="disabled">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="description">Descrizione</label>
                        <textarea v-model="collection.description" class="form-control"
                                  id="description"
                                  name="description"
                                  :disabled="disabled"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row" v-if="showLabels">
                    <div class="col-md-6">
                      <span class="text-bold">Marker</span>
                      <img :src="collection.marker"
                           class="img-responsive collection-marker" v-show="collection.marker"/>
                    </div>

                    <div class="col-md-6" v-show="!disabled">
                      <span class="text-bold">Trascina qui il nuovo marker</span>
                      <dropzone :style="{ border: '2px dashed', height: '200px', width: '100%' }"
                                :uploader="markerUploader" v-show="!disabled"/>
                    </div>
                  </div>

                  <div class="row" style="margin-top: 20px" v-if="showLabels">
                    <div class="col-md-6">
                      <span class="text-bold">Immagine</span>
                      <img :src="collection.image"
                           class="img-responsive collection-marker" v-show="collection.image"/>
                    </div>

                    <div class="col-md-6" v-show="!disabled">
                      <span class="text-bold">Trascina qui la nuova immagine</span>
                      <dropzone :style="{ border: '2px dashed', height: '200px', width: '100%' }"
                                :uploader="imageUploader" v-show="!disabled"/>
                    </div>
                  </div>
                  <br/>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Pubblicato</label>
                        <div class="checkbox">
                          <label>
                            <input type="checkbox"
                                   v-model="collection.published"
                                   :disabled="disabled">
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
            <!-- /.tab-pane -->

          </div>
          <!-- /.tab-content -->

          <div class="box-footer">
            <div class="row">
              <div class="col-md-2 col-md-offset-10">
                <button class="btn btn-success btn-block" v-if="!disabled">
                  <i class="fa fa-circle-o-notch fa-spin" v-if="loader"></i>
                  Salva
                </button>

                <button class="btn btn-warning btn-block" v-on:click.prevent="activateMod"
                        v-if="disabled && $accessControl.isOperator($store.state.profile.profile)">
                  Attiva modifiche
                </button>
              </div>
            </div>
          </div>

        </div>
        <!-- nav-tabs-custom -->
      </div>
    </div>

  </form>
</template>

<script>
  import { clientDateFormat } from '../../filters'
  // import collectionsApi from '../../api/collections'
  import dropzone from 'vue-fineuploader/dropzone'
  import FineUploaderTraditional from 'fine-uploader-wrappers'

  // Import this component
  import datePicker from 'vue-bootstrap-datetimepicker'

  // Import date picker css
  import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'

  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'

  export default {
    props: ['disabled', 'collection', 'loader', 'showLabels'],
    methods: {
      click () {
        this.$emit('click', this.collection)
      },
      error (e) {
        console.log(e)
      },
      activateMod () {
        this.$emit('activate-mod', this.collection)
      }
    },
    data () {
      return {
        config: {
          format: clientDateFormat
        },
        markerUploader: new FineUploaderTraditional({
          options: []
        }),
        imageUploader: new FineUploaderTraditional({
          options: []
        })
      }
    },
    computed: {
      donazione_tipi () {
        return this.$store.state.decoder.decoders['_dDonationTypes']
      }
    },
    // beforeCreate () {
    //   collectionsApi.index()
    //     .then((response) => {
    //       this.collection = response.data.data
    //     })
    // },
    watch: {
      collection: function (val) {
        this.markerUploader = new FineUploaderTraditional({
          options: {
            request: {
              endpoint: process.env.BASE_URL + '/collections/' + val.id + '/marker',
              customHeaders: {
                'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
              },
              inputName: 'marker'
            },
            callbacks: {
              onComplete: (id, name, response) => {
                this.$emit('change-collection-prop', response.data)
              }
            }
          }
        })
        this.imageUploader = new FineUploaderTraditional({
          options: {
            request: {
              endpoint: process.env.BASE_URL + '/collections/' + val.id + '/image',
              customHeaders: {
                'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
              },
              inputName: 'image'
            },
            callbacks: {
              onComplete: (id, name, response) => {
                this.$emit('change-collection-prop', response.data)
              }
            }
          }
        })
      }
    },
    components: {
      datePicker,
      Multiselect,
      dropzone
    }
  }
</script>

<style scoped>
  .collection-marker {
    max-width: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/collections/CollectionsForm.vue